// {translator('Dashboard-Dashboard-StatisticsTab-CardHeaderTransactionsPerMonth', 'Transactions per Month')}

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import Highcharts from "highcharts";
import BasicChart from "highcharts-react-official";
import SpinnerLoading from "../Common/SpinnerLoading";
import { dashboardURL } from "../../Config/Url";

const TransactionsPerMonth = () => {
  const [transactionsPerMonth, setTransactionsPerMonth] = useState();
  const [options, setOptions] = useState();
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);

  let config = {
    headers: {
      "X-IsMockup": false,
    },
  };

  useEffect(() => {
    axios
      .get(
        `${dashboardURL}/total-number-of-transactions/year?year=${new Date().getFullYear()}`,
        config
      )
      .then((result) => {
        let avgTransactions = [];
        for (var i = 0; i < 12; i++) {
          avgTransactions.push(result.data.avgTransactions);
        }

        const x = {
          chart: { type: "column", height: "275px" },
          title: {
            text: translator("Dashboard-TransactionsPerMonth-chartTitle"),
          },
          xAxis: {
            categories: [
              translator("Dashboard-TransactionsPerMonth-monthJanuary"),
              translator("Dashboard-TransactionsPerMonth-monthFebruary"),
              translator("Dashboard-TransactionsPerMonth-monthMarch"),
              translator("Dashboard-TransactionsPerMonth-monthApril"),
              translator("Dashboard-TransactionsPerMonth-monthMay"),
              translator("Dashboard-TransactionsPerMonth-monthJune"),
              translator("Dashboard-TransactionsPerMonth-monthJuly"),
              translator("Dashboard-TransactionsPerMonth-monthAugust"),
              translator("Dashboard-TransactionsPerMonth-monthSeptember"),
              translator("Dashboard-TransactionsPerMonth-monthOctober"),
              translator("Dashboard-TransactionsPerMonth-monthNovember"),
              translator("Dashboard-TransactionsPerMonth-monthDecember"),
            ],
            crosshair: true,
          },
          yAxis: {
            min: 0,
            title: {
              text: translator("Dashboard-TransactionsPerMonth-yAxisTitle"),
            },
          },
          tooltip: {
            headerFormat:
              '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat:
              '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
            footerFormat: "</table>",
            shared: true,
            useHTML: true,
          },
          plotOptions: { column: { borderWidth: 0 } },
          series: [
            {
              name: translator(
                "Dashboard-TransactionsPerMonth-seriesNumberOfTransactions"
              ),
              data: result.data.transactions,
            },
            {
              name: translator(
                "Dashboard-TransactionsPerMonth-seriesAverageNumberOfTransactions"
              ),
              data: avgTransactions,
            },
          ],
          colors: ["#52B9F1", "#CBEAFB"],
          credits: { enabled: false },
          legend: { margin: 0 },
        };
        setOptions(x);
        setIsLoading(false);
      })
      .catch((err) => console.log(err.response));
  }, [transactionsPerMonth]);

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
        <>
          <Card.Body className="dashboard-card-body-transactionsPerMonth">
            {options && (
              <BasicChart highcharts={Highcharts} options={options} />
            )}
          </Card.Body>
        </>
      )}
    </>
  );
};

export default TransactionsPerMonth;
